// Imports
  // React
  import { Link } from 'react-router-dom';
  // Media
  import logo from '../media/logo.png';




// rafce

const NotFound = () => {
  return (
    <>
      <div className="banner-admin">
        <div>
          <img className="banner-admin-logo" src={logo} alt="Logo" />
        </div>
        <div className='banner-admin-options'>
          <p>La sección que buscas no existe</p>
          <Link className="admin-button" to="/tienda/productos">Ir a la Tienda</Link>
        </div>
      </div>
    </>
  )
}

export default NotFound

